var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 68,
    viewBox: "0 0 61 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9456 42.4604C12.35 35.8453 15.0985 20.3798 14.8574 11.4385",
    stroke: "#031333",
    strokeWidth: 3.07158,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4487 52.5191C33.5478 49.598 47.4807 42.3448 54.4199 36.7009",
    stroke: "#031333",
    strokeWidth: 3.07158,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1039 44.2553C23.1559 40.986 29.8591 33.2239 32.2559 28.3291",
    stroke: "#031333",
    strokeWidth: 3.07158,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleShape);
export default __webpack_public_path__ + "static/media/title_shape.0f45ff5d275da07991d9be8739162fec.svg";
export { ForwardRef as ReactComponent };